import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import currentUserStep from '../../../util/currentUserStep';
import './UsanaLogin.css';

const UsanaLogin = () => {
    const {
        loginWithUsanaToken,
        changeLoading,
    } = useContext(AppContext);
    const history = useHistory();

    useEffect(() => {
        const handleLoginWithToken = async () => {
            // Extraer el token directamente de la URL sin que React Router lo decodifique
            const pathParts = window.location.pathname.split('/');
            const tokenFromUrl = pathParts[pathParts.length - 1];
            
            if (!tokenFromUrl || tokenFromUrl === 'UsanaLogin') {
                history.push('/login');
                return;
            }

            // Decodificar el token de la URL (convierte %2F a /, %2B a +, etc.)
            // Usar try-catch en caso de que el navegador ya haya decodificado parcialmente
            let decodedToken;
            try {
                decodedToken = decodeURIComponent(tokenFromUrl);
            } catch (e) {
                // Si falla la decodificación, usar el token tal como está
                decodedToken = tokenFromUrl;
            }
            
            changeLoading(true);
            const userStep = await loginWithUsanaToken(decodedToken);
            
            if (userStep?.data == null) {
                // Login exitoso
                if (userStep || userStep === 0) {
                    changeLoading(false);
                    if (userStep === -1) {
                        history.push('/nonSubscriber');
                    } else {
                        history.push(currentUserStep(userStep));
                    }
                }
            } else {
                // Error en el login
                changeLoading(false);
                history.push('/login?error=auth_failed');
            }
        };

        handleLoginWithToken();
    }, [history, loginWithUsanaToken, changeLoading]);

    return null; // No renderiza nada, solo procesa el login automático
};

export default UsanaLogin;
